import React, { useState, useEffect } from "react";
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import Button from "../../DynamicComp/Button";
import Input from "../../DynamicComp/Input";
import GenericTable from "../../DynamicComp/Table";
import { deleteData, getData, postData, putData } from '../../../global/Globalapi'
import { showAlert } from "../../DynamicComp/Alert";

const UserTypeManager = () => {
  const [formData, setFormData] = useState({
    user_type_name: "",
    description: "",
  });

  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchUserTypes();
  }, []);

  const fetchUserTypes = async () => {
    try {
      const response = await getData("/usertypes");
      setData(response.data);
    } catch (error) {
      showAlert({
                     type: 'error',
                     message: data.message || 'Error fetching usertypes',
                     title: 'error',
                   });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log(formData)
    try {
      if (editId) {
        await putData(`/usertypeupdate/${editId}`, formData);
      } else {
        await postData("/usertypecreate", formData);
      }
      console.log(editId);
      setFormData({ user_type_name: "", description: "" });
      setEditId(null);
      setShowForm(false);
      fetchUserTypes();
    } catch (error) {
     showAlert({
                    type: 'error',
                    message: data.message || 'Operation failed',
                    title: 'error',
                  });
    }
  };

  
  const handleEdit = (item) => {
    setFormData({ user_type_name: item.user_type_name, description: item.description });
    setEditId(item.user_type_id);
    setShowForm(true);
  };

  const handleDelete = async (user_type_id) => {
    try {
      await deleteData(`/usertypedelete/${user_type_id}`);
      fetchUserTypes();
    } catch (error) {
      showAlert({
                     type: 'error',
                     message: data.message || 'Delete failed',
                     title: 'error',
                   });
    }
  };
      const customRenderers = {
          actions: (row) => (
              <div className="flex gap-2 justify-center">
                  <button
                      className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600"
                      onClick={() => handleEdit(row)}
                  >
                      <FaEdit />
                  </button>
                  <button
                      className="bg-red-700 text-white px-2 py-1 rounded hover:bg-red-600"
                      onClick={() => handleDelete(row?.user_type_id)}
                  >
                      <FaTrashAlt />
                  </button>
              </div>
          ),
      };

  const columns = [
    { key: "user_type_name", label: "User Type" },
    { key: "description", label: "Description" },
    {
      key: "actions",
      label: "Actions",
      render: (_, row) => (
        <div className="flex gap-2">
          <Button onClick={() => handleEdit(row.user_type_id)} variant="danger">Edit</Button>
          <Button onClick={() => handleDelete(row.user_type_id)} variant="danger">Delete</Button>
        </div>
      )
    },
  ];

  return (
    <div className="p-8 bg-gray-100 min-h-screen w-full">
      <div className="bg-white shadow p-6 rounded mb-6">
        <div className="flex justify-between mb-4">
          <h2 className="text-xl font-bold text-black">User Types</h2>
          <Button onClick={() => setShowForm(true)} variant="danger">Add User Type</Button>
        </div>
        {/* <GenericTable columns={columns} data={data} /> */}
                            <GenericTable
                                columns={columns}
                                data={data}
                                customRenderers={customRenderers}
                                headerClassName="bg-red-700 text-white"
                                rowKey="user_type_id"
                                stripedRows={true}
                                hoverEffect={true}
                                rowsPerPageOptions={[5, 10, 20]}
                            />
      </div>

      {showForm && (
        <div className="bg-white shadow p-6 rounded">
          <h2 className="text-xl font-bold mb-4">{editId ? "Edit" : "Create"} User Type</h2>
          <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
            <Input
              label="User Type"
              name="user_type_name"
              value={formData.user_type_name}
              onChange={handleChange}
              required
            />
            <Input
              label="Description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
            />
            <div className="col-span-2 flex justify-end gap-4">
              <Button type="submit" variant="danger">
                {editId ? "Update" : "Submit"}
              </Button>
              <Button onClick={() => { setFormData({ user_type_name: "", description: "" }); setShowForm(false); }} variant="danger">
                Cancel
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default UserTypeManager;



